const DateFormat = {}
DateFormat.DashDateString = 'yyyy-MM-dd'

export { DateFormat }
